import { put, PutEffect } from 'redux-saga/effects';

import ScribeShapeElementModel from 'js/models/ScribeShapeElementModel';
import { createElement, CreateShapeElementAction } from 'js/actionCreators/scribeActions';
import { NewScribeShapeElementProps } from 'js/types';

export function* createShapeElement(action: CreateShapeElementAction): Generator<PutEffect, void> {
  const { scribeId, shapeType } = action;
  const elem = new ScribeShapeElementModel({ shapeType } as NewScribeShapeElementProps);

  yield put(createElement(elem, scribeId));
}
